module.exports = __webpack_public_path__ + "media/images/default/homepage/about/Icn-56-2-7a36533f138051492c40dbdb01ffe91c.svg";